export default "__VITE_PUBLIC_ASSET__437a6f85__"